export const brands = {
    interhome: {
        id: 'interhome',
        name: 'Interhome',
        contactUrl: 'https://www.interhome.no/kundeservice/',
        termsUrl: 'https://www.interhome.no/kundeservice/bestillingsvilkar/',
        unleashId: 'interhomeDirectBooking',
    },
    belvilla: {
        id: 'belvilla',
        name: 'Belvilla',
        contactUrl: 'https://www.belvilla.com/contact-us',
        termsUrl: 'https://www.belvilla.com/service',
        unleashId: 'belvillaDirectBooking',
    },
    dancenter: {
        id: 'dancenter',
        name: 'DanCenter',
        contactUrl: 'https://www.dancenter.no/kontakt.html',
        termsUrl: 'https://www.dancenter.no/info/leiebetingelser/',
        unleashId: 'dancenterDirectBooking',
    },
    // TODO REIS-5730 Remove when DanCenter through NextPax is in production
    dancenter_np: {
        id: 'dancenter',
        name: 'DanCenter',
        contactUrl: 'https://www.dancenter.no/kontakt.html',
        termsUrl: 'https://www.dancenter.no/info/leiebetingelser/',
        unleashId: 'dancenterDirectBooking',
    },
    danland: {
        id: 'danland',
        name: 'Danland',
        contactUrl: 'https://www.danland.no/callback.html',
        termsUrl: 'https://www.danland.no/info/leiebetingelser/',
        unleashId: 'danlandDirectBooking',
    },
    sologstrand: {
        id: 'sologstrand',
        name: 'Sol og Strand',
        contactUrl: 'https://www.sologstrand.no/kundeservice',
        termsUrl: 'https://www.sologstrand.no/praktiske-info/bestillinger',
        unleashId: 'sologstrandDirectBooking',
    },
    tui: {
        id: 'tui',
        name: 'TUI',
        contactUrl: 'TODO',
        termsUrl: 'https://www.tuivillas.com/us_en/terms_and_conditions',
        unleashId: 'tuiDirectBooking',
    },
    yourrentals: {
        id: 'yourrentals',
        name: 'Your.Rentals',
        contactUrl: 'TODO',
        termsUrl: 'TODO',
        unleashId: 'yourrentalsDirectBooking',
    },
    novasol: {
        id: 'novasol',
        name: 'Novasol',
        contactUrl: 'https://www.novasol.no/hjelp',
        termsUrl: 'https://www.novasol.no/hjelp/generelle-vilkar-og-leiebetingelser',
        unleashId: 'novasolDirectBooking',
    },
};

export const importBrandsList = () => Object.values(brands);

export const brandsViaNextPaxList = () => Object.values(brands).filter((brand) => brand.name !== 'Novasol');

export const isBrandViaNextPax = (brandId) =>
    Object.keys(brands)
        .filter((id) => id !== 'novasol')
        .includes(brandId);

export const isImportBrandEnabled = (brandName, unleash) => {
    const matchedBrand = importBrandsList().find((brand) => brand.name === brandName);

    return unleash[matchedBrand?.unleashId] ?? false; // return false if not an import brand or if unleash toggle is not setup
};

export const isNextPaxBrandEnabled = (brandName, unleash) => {
    if (brandName === 'Novasol') {
        return false;
    } else {
        return isImportBrandEnabled(brandName, unleash);
    }
};
